import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import { useOptions } from '../../../OptionsContext';

const restoreButtonRules = ({ theme, withMargin }) => ({
  cursor: 'pointer',
  opacity: '.9',

  ':hover': {
    opacity: '1',
  },
  extend: [
    {
      condition: withMargin,
      style: {
        margin: `0 ${theme.margin.xlarge}`,
      },
    },
  ],
});

const svgRules = () => ({
  height: '2.5em',
  width: '3.5em',
});

function RestorePlayer({ withMargin }) {
  const options = useOptions();
  const { css } = useFela({ withMargin });

  if (!options.restoreFromMiniPlayer) {
    return null;
  }

  return (
    <div
      onClick={options.restoreFromMiniPlayer}
      className={css(restoreButtonRules)}
    >
      <svg className={css(svgRules)} viewBox="0 0 78 57">
        <g fill="none" fillRule="evenodd">
          <rect width="63" height="42" x="2" y="13" stroke="rgb(255, 255, 255)" strokeWidth="4" rx="2" />
          <rect width="63" height="42" x="11" rx="2" fill="rgb(255, 255, 255)" stroke="rgb(255, 255, 255)" strokeWidth="4" />
        </g>
      </svg>
    </div>
  );
}

RestorePlayer.propTypes = {
  withMargin: PropTypes.bool,
};

RestorePlayer.defaultProps = {
  withMargin: true,
};

export default React.memo(RestorePlayer);
